import { createFileRoute } from "@tanstack/react-router";

import { HStack, VStack } from "@/components/Layout";
import usePersonParams from "@/routes/_staff/person/$id/-hooks/usePersonParams";

import AddressSection from "../../../../-components/PersonProfileSection/personal-information/AddressSection";
import FamilySection from "../../../../-components/PersonProfileSection/personal-information/FamilySection";
import PersonalContactSection from "../../../../-components/PersonProfileSection/personal-information/PersonalContactSection";
import PersonalIdSection from "../../../../-components/PersonProfileSection/personal-information/PersonalIdSection";
import PersonalInformationNavigation from "../../../../-components/PersonProfileSection/personal-information/PersonalInformationNavigation";
import SnsAndItSection from "../../../../-components/PersonProfileSection/personal-information/SnsAndItSection";

export const Route = createFileRoute(
  "/_staff/person/alumni/$id/_profile/personal-information/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = usePersonParams();

  return (
    <HStack className="h-full">
      <nav className="sticky top-0 h-fit w-60 p-8">
        <PersonalInformationNavigation />
      </nav>
      <div className="flex-1 overflow-y-auto p-8">
        <VStack className="w-full gap-4">
          <PersonalIdSection personId={id} />
          <PersonalContactSection personId={id} />
          <AddressSection personId={id} />
          <SnsAndItSection personId={id} />
          <FamilySection personId={id} />
        </VStack>
      </div>
    </HStack>
  );
}
